import { MAP_SET_TRANSPORT_HISTORY_ITEMS_CONDITIONS, SET_HISTORY_SELECTED_TIME, SET_HISTORY_TRACKS_VISIBLE, SET_IS_HISTORY_OPEN, SET_TRANSPORT_HISTORY_TRACKS_ITEMS, SET_TRANSPORT_SELECTED_DATE } from 'app/utils/constants';

export const setTransportBroadcastRecords = (terid, events, records) => {
    return {
        type: 'MAP_SET_TRANSPORT_BROADCAST_RECORDS',
        payload: {
            terid,
            events,
            records,
        },
    };
};

export const addTransportItemsCondition = (data) => {
    return {
        type: 'MAP_ADD_TRANSPORT_ITEMS_CONDITION',
        payload: {
            data,
        },
    };
};

export const setTransportItemsActivity = (data) => {
    return {
        type: 'MAP_SET_TRANSPORT_ITEMS_ACTIVITY',
        payload: {
            data,
        },
    };
};

export const addTransportItemsCommand = (data) => {
    return {
        type: 'MAP_ADD_TRANSPORT_ITEMS_COMMAND',
        payload: {
            data,
        },
    };
};

export const setMapRef = (ref) => {
    return {
        type: 'MAP_SET_REF',
        payload: {
            ref,
        },
    };
};

export const addGeofence = (data) => {
    return {
        type: 'MAP_ADD_GEOFENCE',
        payload: {
            data,
        },
    };
};

export const setGeofenceCheckedId = (items) => {
    return {
        type: 'MAP_SET_GEOFENCE_CHECKED_ID',
        payload: {
            items,
        },
    };
};

export const addGeofenceCheckedId = (id) => {
    return {
        type: 'MAP_ADD_GEOFENCE_CHECKED_ID',
        payload: {
            id,
        },
    };
};

export const deleteGeofenceCheckedId = (id) => {
    return {
        type: 'MAP_DELETE_GEOFENCE_CHECKED_ID',
        payload: {
            id,
        },
    };
};

export const addGeofenceCheckedItemsId = (items) => {
    return {
        type: 'MAP_ADD_GEOFENCES_CHECKED_ID',
        payload: {
            items,
        },
    };
};

export const setTask = (data) => {
    return {
        type: 'MAP_SET_TASK',
        payload: {
            data,
        },
    };
};

export const setTaskSortSelectedItem = (data) => {
    return {
        type: 'MAP_SET_TASK_SORT_SELECTED_ITEM',
        payload: {
            data,
        },
    };
};

export const setTaskSelectedItem = (data) => {
    return {
        type: 'MAP_SET_TASK_SELECTED_ITEM',
        payload: {
            data,
        },
    };
};

export const setTransportSelectedItem = (data) => {
    return {
        type: 'MAP_SET_TRANSPORT_SELECTED_ITEM',
        payload: {
            data,
        },
    };
};

export const addTransportCheckedId = (id) => {
    return {
        type: 'MAP_ADD_TRANSPORT_CHECKED_ITEM',
        payload: {
            id,
        },
    };
};

export const setTransportSortSelectedItem = (data) => {
    return {
        type: 'MAP_SET_TRANSPORT_SORT_SELECTED_ITEM',
        payload: {
            data,
        },
    };
};

export const deleteTransportCheckedItem = (id) => {
    return {
        type: 'MAP_DELETE_TRANSPORT_CHECKED_ITEM',
        payload: {
            id,
        },
    };
};

export const setTransportCheckedItem = (items) => {
    return {
        type: 'MAP_SET_TRANSPORT_CHECKED_ITEM',
        payload: {
            items,
        },
    };
};

export const setBounds = (zoom, bounds) => {
    return {
        type: 'MAP_SET_BOUNDS',
        payload: {
            zoom,
            bounds,
        },
    };
};

export const setTransportConditionSelectedItem = (data) => {
    return {
        type: 'MAP_SET_TRANSPORT_CONDITION_SELECTED_ITEM',
        payload: {
            data,
        },
    };
};

export const setTransportConditionSelectedDatetime = (datetime) => {
    return {
        type: 'MAP_SET_TRANSPORT_CONDITION_SELECTED_DATETIME',
        payload: {
            datetime,
        },
    };
};

export const setGeofenceMode = (value) => {
    return {
        type: 'MAP_SET_GEOFENCE_MODE',
        payload: {
            value,
        },
    };
};

export const setGeofenceUpdateItem = (data) => {
    return {
        type: 'MAP_SET_GEOFENCE_UPDATED_ITEM',
        payload: {
            data,
        },
    };
};

export const setGeofenceChangedItem = (data) => {
    return {
        type: 'MAP_SET_GEOFENCE_CHANGED_ITEM',
        payload: {
            data,
        },
    };
};

export const setLayerSelected = (value) => {
    return {
        type: 'MAP_SET_LAYER_SELECTED',
        payload: {
            value,
        },
    };
};

export const setZoom = (value) => {
    return {
        type: 'MAP_SET_ZOOM',
        payload: {
            value,
        },
    };
};

export const updateGeofence = (id, data) => {
    return {
        type: 'MAP_UPDATE_GEOFENCE',
        payload: {
            id,
            data,
        },
    };
};

export const deleteGeofence = (id) => {
    return {
        type: 'MAP_DELETE_GEOFENCE',
        payload: {
            id,
        },
    };
};

export const setGeofenceGroupItems = (items) => {
    return {
        type: 'MAP_SET_GEOFENCE_GROUP_ITEMS',
        payload: {
            items,
        },
    };
};

export const setTransportCheckedItemTask = (data) => {
    return {
        type: 'MAP_SET_TRANSPORT_CHECKED_ITEM_TASK',
        payload: {
            data,
        },
    };
};

export const setFilterTab = (value) => {
    return {
        type: 'MAP_SET_FILTER_TAB',
        payload: {
            value,
        },
    };
};

export const deleteTaskFilterCheckedItem = (value) => {
    return {
        type: 'MAP_DELETE_TASK_FILTER_CHECKED_ITEM',
        payload: {
            value,
        },
    };
};

export const addTaskFilterCheckedItem = (value) => {
    return {
        type: 'MAP_ADD_TASK_FILTER_CHECKED_ITEM',
        payload: {
            value,
        },
    };
};

export const setTransportItems = (items) => {
    return {
        type: 'MAP_SET_TRANSPORT_ITEMS',
        payload: {
            items,
        },
    };
};

export const setTransportSearchValue = (value) => {
    return {
        type: 'MAP_SET_TRANSPORT_SEARCH_VALUE',
        payload: {
            value,
        },
    };
};

export const setTransportGeofenceView = (flag) => {
    return {
        type: 'MAP_SET_TRANSPORT_GEOFENCE_VIEW',
        payload: {
            flag,
        },
    };
};

export const setGeofenceSearchValue = (value) => {
    return {
        type: 'MAP_SET_GEOFENCE_SEARCH_VALUE',
        payload: {
            value,
        },
    };
};

export const setTaskSearchValue = (value) => {
    return {
        type: 'MAP_SET_TASK_SEARCH_VALUE',
        payload: {
            value,
        },
    };
};

export const deleteTaskColumnCheckedItem = (value) => {
    return {
        type: 'MAP_DELETE_TASK_COLUMN_CHECKED_ITEM',
        payload: {
            value,
        },
    };
};

export const addTaskColumnCheckedItem = (value) => {
    return {
        type: 'MAP_ADD_TASK_COLUMN_CHECKED_ITEM',
        payload: {
            value,
        },
    };
};

export const setActiveWindow = (value) => {
    return {
        type: 'MAP_SET_ACTIVE_WINDOW',
        payload: {
            value,
        },
    };
};

export const setTransportWindowMinimize = (flag) => {
    return {
        type: 'MAP_SET_TRANSPORT_WINDOW_MINIMIZE',
        payload: {
            flag,
        },
    };
};

export const setTransportSelectedItemConditionOptions = (data) => {
    return {
        type: 'MAP_SET_TRANSPORT_SELECTED_ITEM_CONDITION_OPTIONS',
        payload: {
            data,
        },
    };
};

export const setTransportSelectedData = (value) => {
    return {
        type: 'MAP_SET_TRANSPORT_SELECTED_DATE',
        payload: {
            value,
        },
    };
};

export const setTransportSelectedItemBroadcast = (data) => {
    return {
        type: 'MAP_SET_TRANSPORT_SELECTED_ITEM_BROADCAST',
        payload: {
            data,
        },
    };
};

export const setTransportSelectedItemConditions = (items) => {
    return {
        type: 'MAP_SET_TRANSPORT_SELECTED_ITEM_CONDITIONS',
        payload: {
            items,
        },
    };
};
export const setTransportHistoryItemsConditions = (items) => {
    return {
        type: MAP_SET_TRANSPORT_HISTORY_ITEMS_CONDITIONS,
        payload: {
            items,
        },
    };
};

export const setTransportTab = (value) => {
    return {
        type: 'MAP_SET_TRANSPORT_TAB',
        payload: {
            value,
        },
    };
};

export const setBroadcastSelectedItem = (data) => {
    return {
        type: 'MAP_SET_TRANSPORT_BROADCAST_SELECTED_ITEM',
        payload: {
            data,
        },
    };
};

export const setTransportConditionCheckedItem = (items) => {
    return {
        type: 'MAP_SET_TRANSPORT_CONDITION_CHECKED_ITEM',
        payload: {
            items,
        },
    };
};

export const addTransportConditionCheckedItem = (items) => {
    return {
        type: 'MAP_ADD_TRANSPORT_CONDITION_CHECKED_ITEM',
        payload: {
            items,
        },
    };
};

export const deleteTransportConditionCheckedItem = (items) => {
    return {
        type: 'MAP_DELETE_TRANSPORT_CONDITION_CHECKED_ITEM',
        payload: {
            items,
        },
    };
};

export const setTransportConditionCheckedType = (value) => {
    return {
        type: 'MAP_SET_TRANSPORT_CONDITION_CHECKED_TYPE',
        payload: {
            value,
        },
    };
};

export const setTransportSelectedItemParkingPointsOptions = (data) => {
    return {
        type: 'MAP_SET_TRANSPORT_SELECTED_ITEM_PARKING_POINTS_OPTIONS',
        payload: {
            data,
        },
    };
};

export const deleteTransportFilterCheckedItem = (value) => {
    return {
        type: 'MAP_DELETE_TRANSPORT_FILTER_CHECKED_ITEM',
        payload: {
            value,
        },
    };
};

export const addTransportFilterCheckedItem = (value) => {
    return {
        type: 'MAP_ADD_TRANSPORT_FILTER_CHECKED_ITEM',
        payload: {
            value,
        },
    };
};

export const deleteTransportColumnCheckedItem = (value) => {
    return {
        type: 'MAP_DELETE_TRANSPORT_COLUMN_CHECKED_ITEM',
        payload: {
            value,
        },
    };
};

export const addTransportColumnCheckedItem = (value) => {
    return {
        type: 'MAP_ADD_TRANSPORT_COLUMN_CHECKED_ITEM',
        payload: {
            value,
        },
    };
};

export const setConditionHdop = (value) => {
    return {
        type: 'MAP_SET_TRANSPORT_CONDITION_HDOP',
        payload: {
            value,
        },
    };
};

export const setTransportSelectedItemTask = (value) => {
    return {
        type: 'MAP_SET_TRANSPORT_SELECTED_ITEM_TASK',
        payload: {
            value,
        },
    };
};

export const setTransportFilterCheckedType = (value) => {
    return {
        type: 'MAP_SET_TRANSPORT_FILTER_CHECKED_TYPE',
        payload: {
            value,
        },
    };
};

export const setTransportMarkedCheckedItem = (items) => {
    return {
        type: 'MAP_SET_TRANSPORT_MARKED_CHECKED_ITEM',
        payload: {
            items,
        },
    };
};

export const resetTransportFilterCheckedItems = () => (dispatch, getState) => {
    const { transportFilterCheckedItems } = getState().map;

    if (!transportFilterCheckedItems.includes('parking')) {
        dispatch({
            type: 'MAP_ADD_TRANSPORT_FILTER_CHECKED_ITEM',
            payload: { value: 'parking' },
        });
    }
};

export const setIsHistoryOpen = (value) => {
    return {
        type: SET_IS_HISTORY_OPEN,
        payload: {
            value,
        },
    };
};

export const setHistorySelectedTime = (value) => {
    return {
        type: SET_HISTORY_SELECTED_TIME,
        payload: {
            value,
        },
    };
};

export const setTransportSelectedDate = (value) => {
    return {
        type: SET_TRANSPORT_SELECTED_DATE,
        payload: {
            value,
        },
    };
};
export const setTransportHistoryTracksItems = (items) => {
    return {
        type: SET_TRANSPORT_HISTORY_TRACKS_ITEMS,
        payload: {
            items,
        },
    };
};

export const setHistoryTracksVisible = (value) => {
    return {
        type: SET_HISTORY_TRACKS_VISIBLE,
        payload: {
            value,
        },
    };
};
